<account-mapping-grid
  [loading]="loading()"
  [paginatedAccountMapping]="accountMapping$ | async"
  [unmappedAccounts]="unmappedAccounts$ | async"
  (importAccountMapping)="openAccountMappingImportDialog()"
  (manageAccountMapping)="
    openAccountMappingManagementDialog({
      account_mapping_id: $event?.id,
      category_account_id: $event?.gl_category?.id,
      regular_account_id: $event?.gl_account?.id,
    })
  "
  (deleteAccountMapping)="deleteAccountMapping($event)"
  (createMappingFromAccount)="openAccountMappingManagementDialog({ regular_account_id: $event?.id })"
></account-mapping-grid>
